import SignInMain from './SignInMain.vue'
import AuthLayout from "@/layouts/AuthLayout.vue"

const config = {
	mainRoute: {
		name: "SignIn",
		path: "/",
		component: SignInMain,
		layout: AuthLayout
	}
}

export { config }